import { useEffect, useState } from 'react';
import ImageUploadWithPreview from '../ImageUpload';
import { Container, UploadContainer } from './style';

type Props = {
  values?: string[];
  onChange: (values: string[]) => void;
};

export const MultipleImageUploader = (props: Props) => {
  const [values, setValues] = useState<string[]>(props.values ?? []);

  useEffect(() => {
    if (props.values?.[props.values.length - 1] !== '') {
      setValues([...(props.values ?? []), '']);
    }
  }, [props.values]);

  return (
    <Container>
      {values.map((item, idx) => (
        <UploadContainer key={`${idx}_${item}`}>
          <ImageUploadWithPreview
            value={item}
            onChange={(value) => {
              const newValues = [...(props.values ?? [])];
              newValues[idx] = value!;
              props.onChange(newValues);
            }}
          />
        </UploadContainer>
      ))}
    </Container>
  );
};
